import React, { useContext, useEffect } from 'react';
import cn from 'classnames';
import ButtonWithIcon from 'chameleon/packages/blue-book-player/library/button-with-icon';
import { COLUMN_WIDTHS } from 'chameleon/packages/blue-book-player/constants/questionColumns';

const ColumnExpander = (props) => {
  const {
    expandedContext,
    setExpandedColumn,
    column,
    firstColumnEl,
    secondColumnEl,
  } = props;
  const expandedColumn = useContext(expandedContext);

  const clearExpandedColumns = () => {
    firstColumnEl.style = null;
    secondColumnEl.style = null;
    firstColumnEl.classList.remove('expanded');
    secondColumnEl.classList.remove('expanded');
  };

  const doExpandColumn = (col) => {
    if (col === 'left') {
      firstColumnEl.style.width = `calc(${COLUMN_WIDTHS.EXPANDED} - 2px)`;
      secondColumnEl.style.width = `calc(${COLUMN_WIDTHS.COLLAPSED} - 2px)`;
      firstColumnEl.classList.add('expanded');
      secondColumnEl.classList.remove('expanded');
    } else if (col === 'right') {
      firstColumnEl.style.width = `calc(${COLUMN_WIDTHS.COLLAPSED} - 2px)`;
      secondColumnEl.style.width = `calc(${COLUMN_WIDTHS.EXPANDED} - 2px)`;
      firstColumnEl.classList.remove('expanded');
      secondColumnEl.classList.add('expanded');
    }
  };

  const onClick = () => {
    setExpandedColumn(expandedColumn ? null : column);

    //column already expanded, remove
    if (expandedColumn) {
      clearExpandedColumns();
    } else {
      doExpandColumn(column);
    }
  };

  useEffect(() => {
    if (expandedColumn) {
      doExpandColumn(expandedColumn);
    } else {
      clearExpandedColumns();
    }
  }, [expandedColumn]);

  const isColumnActionedOn = column === expandedColumn;
  const isRightColumn = column === 'right';
  const iconClassName = cn({
    'rotate-180': isColumnActionedOn && column === 'left',
    'rotate-90': isColumnActionedOn && isRightColumn,
    'rotate-[270deg]': expandedColumn !== 'right' && isRightColumn,
  });

  return (
    <ButtonWithIcon
      isBlueBookIcon
      isIcon
      withFrame
      icon="column_expander"
      onClick={onClick}
      data-cy={`${column}-column-expander`}
      iconClassName={iconClassName}
      className="opacity-70 hover:opacity-100 shadow-[0_6px_6px_0_rgba(0,0,0,0.17)] z-12"
      accessibility={{
        tabIndex: -1,
        'aria-hidden': 'true',
      }}
    />
  );
};

export default ColumnExpander;
